<template>
  <div id="app">
    <Hero :sm="userStore.hasReferral" />
    <div class="home-callout text-left">
      <div class="af-container-lg" v-if="!userStore.hasReferral">
        <b-row>
          <b-col md="10" lg="8">
            <div class="content">
              <h2 class="h4">Help your friends discover AT&T, and you’ll both be rewarded! Here’s how it works:</h2>
              <div class="list-group">
                <div class="list-item"><span>1.</span>You must be an existing AT&amp;T Wireless or Fiber customer.</div>
                <div class="list-item"><span>2.</span>Use the button below to get your exclusive referral link.</div>
                <div class="list-item"><span>3.</span>Share your referral link with friends, family &amp; neighbors to earn rewards.</div>
              </div>
              <p><strong>For every person who uses your referral code to get new AT&T Wireless or Fiber, you and your friend will receive a bill credit. The more you share, the more you earn!</strong></p>
              <div class="button-container">
                <ReferralCodeModal />
              </div>
              <Faq type="existing" />
            </div>
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <div v-else class="af-container">
        <div class="content-block text-center" ref="referral">
          <h2 class="h4 mb-4">Help your friends and family discover AT&T, and you’ll both earn bill credits. Here’s how it works:</h2>
          <p class="mb-3">Copy this unique URL and share with friends through text or social media.</p>
          <p><strong>The more you share, the more you earn!</strong></p>
          <div class="my-4 my-sm-6 py-6 bg-light px-3">
            <b-input-group class="input-group mx-auto">
              <b-form-input ref="urlInput" v-model="userStore.referral.uri"/>
              <b-input-group-append>
                <b-button @click="copyText" variant="primary">Copy</b-button>
              </b-input-group-append>
            </b-input-group>
            <p v-if="showCopied === true" class="mb-3"><small>Text Copied!</small></p>
            <div class="mt-3 text-center">
              <a :href="downloadUrl" target="_blank" class='link-icon'>
                <img src="@/assets/svg/download.svg" alt="Download">
                Printable QR Code
              </a>
            </div>
          </div>
          <Faq type="existing" />
        </div>
      </div>
  </div>     
  <LegalDisclaimer />
  </div>
</template>

<script>
  import { mapStores, mapActions } from 'pinia'
  import useUserStore from '@/stores/user'

  import Hero from '@/components/Hero'
  import ReferralCodeModal from '@/components/ReferralCodeModal'
  import Faq from '@/components/Faq'
  import LegalDisclaimer from '@/components/LegalDisclaimer'


  export default {
    name: 'app',
    components: {
      Hero,
      Faq,
      ReferralCodeModal,
      LegalDisclaimer,
    },
    computed: {
      ...mapStores(useUserStore),
      downloadUrl() {
        const language = window.location.href.indexOf('/es-us/') > -1 ? 'es' : 'en'
        return `${this.userStore.apiRoot}/api/referrals/${this.userStore.referral.code}/download/${language}`
      }
    },
    data() {
      return {
        showCopied: false,
      }
    },
    methods: {
      ...mapActions(useUserStore, ['initialize']),
      async copyText () {
        if(this.showCopied === true) return
        this.showCopied = true
        this.$refs.urlInput.focus();
        await navigator.clipboard.writeText(this.userStore.referral.uri);
        
        setTimeout(() => {
          this.showCopied = false
        }, 2000)
      },
    },
    mounted() {
      this.initialize()
    }
  }
</script>

<style lang="scss" scoped>
.content {
  padding: 70px 60px 0;
  @include media-breakpoint-down(md) {
    padding: 70px 45px 0 45px;
  }
  @include media-breakpoint-down(sm) {
    padding: 40px 20px 30px;
  }
}
.list-group {
  padding: 25px 0;
}
.list-item {
  padding: 12px 20px;
  span {
    @include font-bold;
    color: $brand-blue;
    padding-right: 10px;
  }
}
.button-container {
  margin: 50px 0 100px 0;
}

.secondary {
  h2 {
    margin-bottom: 30px;
  }
  p {
    margin-bottom: 30px;
  }
}
.home-callout {
  .row {
    margin: 0;
  }
}
</style>